import React, { useEffect, useState } from "react";
import {
  doc,
  collection,
  query,
  updateDoc,
  getDoc,
  orderBy,
  addDoc,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { db, auth } from "../api/firebase";
import { useCollection } from "react-firebase-hooks/firestore";

import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

import TextField from "@mui/material/TextField";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import { Grid } from "@mui/material";
import Loader1Row from "./Loader1Row";
import ModalForm from "./ModalForm";
import GetUserInfo from "./GetUserInfo";
// redux - use
import { useNotification } from "../redux/useNotification";

const GroupTypeTable = ({ pending }) => {
  // redux - Notification
  const { displayNotification } = useNotification();

  const [basesCount, loading, error] = useCollection(collection(db, "group"));

  const [dataloading, setDataLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [requestId, setRequestId] = useState("");
  const [d_loding, setD_loading] = useState(false);
  const [originalRows, setOriginalRows] = useState([]);

  // 表示・非表示
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState("");
  const [target, setTarget] = useState("");
  const handleEdit = (e, id, target) => {
    setOpen(true);
    setForm(e);
    setRequestId(id);
    setTarget(target);
  };

  const q = query(collection(db, "groupType"), orderBy("createdAt", "desc"));
  const [collectionData] = useCollection(q);
  const data = collectionData?.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const q_pending = query(
    collection(db, "group"),
    where("isPublish", "==", false),
    orderBy("createdAt", "desc")
  );
  const [collectionDataPending] = useCollection(q_pending);
  const pendingData = collectionDataPending?.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  useEffect(() => {
    setOriginalRows(pending || data);
    setRows(pending || data);
  }, [collectionData, pending]);

  // テーブル使用コンテナ
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // テーブル使用handle
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //   権限変更関連handle
  const publishChange = async (id, type) => {
    // 権限変更
    const pub = await getDoc(doc(db, "groupType", id));
    await updateDoc(doc(db, "groupType", id), {
      [type]: !pub.data()[type],
    });
    setD_loading(false);
    displayNotification({
      message:
        "掲載権限が変更されました。",
      success: "success",
    });
  };

  const handleChange = async (e) => {
    setD_loading(true);
    await publishChange(e.target.value, e.target.name);
  };

  if (loading) {
    return <Loader1Row />;
  }

  return (
    <>
      <ModalForm
        form={form}
        setOpen={setOpen}
        open={open}
        requestId={requestId}
        target={target}
      />

      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 240, borderRadius: 1 }}>
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            sx={{ minWidth: 650 }}
          >
            <TableHead>
              {/* ヘッダー情報 */}
              <TableRow>
                <TableCell>掲載</TableCell>
                <TableCell>創設者</TableCell>
                <TableCell>グループタイプ</TableCell>
                <TableCell>登録日</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows?.map((row, index) => (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={index}
                  className="flex group"
                >
                  {/* 掲載 */}
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={row.isPublish}
                          onChange={handleChange}
                          name="isPublish"
                          disabled={d_loding}
                          value={row.id}
                        />
                      }
                      label={row.isPublish ? "掲載" : ""}
                    />
                  </TableCell>

                  {/* 創設者 */}
                  <TableCell component="th" scope="row">
                    {row?.registered && (
                      <div className="flex flex-row items-center rounded-md border shadow-md hover:shadow-xl duration-150 hover:cursor-pointer p-2 w-fit">
                        <>
                          <div className="hidden lg:block">
                            <GetUserInfo
                              uid={row?.registered}
                              target="avatar"
                              size={24}
                            />
                          </div>
                          <GetUserInfo uid={row?.registered} target="name" />
                        </>
                      </div>
                    )}
                  </TableCell>

                  {/* グループ名 */}
                  <TableCell component="th" scope="row">
                    <div className="flex flex-row items-center">
                      <div>{row?.groupType}</div>
                    </div>
                  </TableCell>

                  {/* 登録日 */}
                  <TableCell align="left">
                    <Grid className="">
                      {new Date(row.createdAt?.toDate()).toLocaleString()}
                    </Grid>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="ml-2 mt-2">
          {/* 掲載店舗：{publish.docs.length} / {realtimeRequestShop.docs.length} */}
        </div>

        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={pending?.length || data?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          showFirstButton
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
};

export default GroupTypeTable;

// テーブル検索
// https://smartdevpreneur.com/the-easiest-way-to-implement-material-ui-table-search/
